import { Theme } from "waapi/waap-ui/components/Theme/Theme.js";
import { lightTheme } from "../../../styles/theme.js";

export const WithTheme = ({ children }: { children: React.ReactNode }) => {
    return <Theme theme={lightTheme}>{children}</Theme>;
};
